import { getDeveloperApi } from '@squareup/dex-data-shared-developer-api';
import { Link } from '@squareup/dex-ui';
import {
  Box,
  Heading20,
  Heading30,
  Paragraph30,
} from '@squareup/dex-ui-shared-base';
import { MarketActivityIndicator } from '@squareup/dex-ui-shared-market';
import React from 'react';

import styles from './spec-artifacts-page-content.module.css';

const SpecArtifactsPageContent = () => {
  const { data: versions, isLoading } =
    getDeveloperApi().useGetSpecificationVersionsQuery(undefined);

  return isLoading ? (
    <Box padding={{ top: '2x' }}>
      <MarketActivityIndicator />
    </Box>
  ) : (
    <Box>
      <Heading30 margin={{ bottom: '1x' }}>Earlier References</Heading30>
      <Paragraph30>
        This page contains links to technical reference material for
        Square&apos;s APIs and SDKs for non-current versions. Current references
        are always accessible from the navigation.
      </Paragraph30>
      <Paragraph30 margin={{ top: '1x' }}>
        <Link
          href="/docs/changelog/connect"
          className={styles['artifact-link']}
          trackingId="artifact-changelog-link"
          passHref
        >
          Read the changelog &gt;
        </Link>
      </Paragraph30>
      <Heading20 margin={{ top: '3x', bottom: '1x' }}>Connect V2 API</Heading20>
      <Box as="ul" padding={{ left: '3x' }} data-testid="artifacts-list">
        {versions?.map((version) => {
          const href = `/reference/square_${version}`;

          return (
            <Box as="li" key={version} margin={{ bottom: '1x' }}>
              <Link
                href={href}
                className={styles['artifact-link']}
                trackingId="artifact-version-link"
                passHref
              >
                Version {version}
              </Link>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
};

export { SpecArtifactsPageContent };
